import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import './etica.css';

function Etica() {
  return (
    
  <div>
    <div className='row'>
      <div className="fixed-header">
        <h3 className='title'>Comité de Ética y Prevención de Conflictos de Interés<br /> de la Secretaría de Bienestar e Inclusión Social</h3>
        <hr className='hr-gob' />
      </div>
    </div>

   {/* Nueva sección de íconos */}
   <div className="icon-section" style={{ display: 'flex', justifyContent: 'center', gap: '50px', padding: '20px 0' }}>

        
        <a href="/Cepci/Cepcidoc04" target="_blank" rel="noopener noreferrer"
         style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textDecoration: 'none',
        }}>
          <i className="fa-duotone fa-solid fa-book" style={{ fontSize: '40px' }}></i>
          <span style={{ marginTop: '8px', color: '#691B31' }}><b>Código de Ética</b></span>
        </a>

        <a href="/Cepci/Cepcidoc11" target="_blank" rel="noopener noreferrer"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textDecoration: 'none',
        }}>
          <i className="fas fa-shield-alt" style={{ fontSize: '40px' }}></i>
          <span style={{ marginTop: '8px', color: '#691B31' }}><b>Protocolo Cero</b></span>
        </a>

        <a href="/Cepci/Cepcidoc03" target="_blank" rel="noopener noreferrer"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textDecoration: 'none',
        }}>
          <i className="fas fa-book" style={{ fontSize: '40px' }}></i>
          <span style={{ marginTop: '8px', color: '#691B31' }}><b>Código de Conducta</b></span>
       </a>
      </div>

      {/* Contenedor con clase para aplicar ancho de un tercio */}
      <div className="accordion-container">
        <Accordion>
          <Accordion.Item eventKey="1" className="accordion-CONTR1">
            <Accordion.Header>Normatividad</Accordion.Header>

            <Accordion.Body>
            Acuerdo mediante el cual se crea el CEPCI
              <a href="/Cepci/Cepcidoc01">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body>
            Bases de Integración, Organización y Funcionamiento del CEPCI
              <a href="/Cepci/Cepcidoc02">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body>
            Lineamientos Generales Integración, Organización y Funcionamiento de los Comités de Ética
              <a href="/Cepci/Cepcidoc09">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body>
            Código de Ética de la Administración Pública del Estado de Hidalgo 2019
              <a href="/Cepci/Cepcidoc04">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body>
            Código de Conducta Para los Servidores Públicos de la SEBISO
              <a href="/Cepci/Cepcidoc03">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body>
            Protocolo Cero para la Prevención, Atención y Sanción del Acoso Sexual y/o Laboral en la Administración Pública del Estado de Hidalgo
              <a href="/Cepci/Cepcidoc11">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body>
            Procedimiento y Protocolo Para la Recepción de Denuncias del Comité de Ética y Prevención de Conflictos de Interés
              <a href="/Cepci/Cepcidoc10">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body>
            Formato de Denuncia
              <a href="https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/cepci/2023/Form_Den_CEPCI_2023.docx">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="2" className="accordion-CONTR2">
            <Accordion.Header>
            Programas de Trabajo
            </Accordion.Header>
            <Accordion.Body className="accordion-body">
            Programa Anual de Trabajo 2025
              <a href="/Cepci/Cepcidoc17">
                <button  style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body className="accordion-body">
            Programa Anual de Trabajo 2024
              <a href="/Cepci/Cepcidoc06">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3" className="accordion-CONTR3">
            <Accordion.Header>
           Informes de Actividades
            </Accordion.Header>
            <Accordion.Body className="accordion-body">
            Informe Anual de Actividades 2024
              <a href="/Cepci/Cepcidoc16">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body className="accordion-body">
            Informe Anual de Actividades 2023
              <a href="/Cepci/Cepcidoc07">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4" className="accordion-CONTR4">
            <Accordion.Header>
            Encuestas
            </Accordion.Header>
            <Accordion.Body className="accordion-body">
            Encuesta de Evaluación al Conocimiento y Cumplimiento del Código de Ética de la Administración Pública del Estado de Hidalgo 2024
              <a href="/Cepci/Cepcidoc13">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body className="accordion-body">
            Encuesta 2024 para Evaluar el Conocimiento y Cumplimiento del Código de Conducta
              <a href="/Cepci/Cepcidoc14">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body className="accordion-body">
            Encuesta de Evaluación 2024 del Conocimiento y Cumplimiento del Comité de Ética y Prevención de Conflictos de Interés de la SEBISO
              <a href="/Cepci/Cepcidoc15">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
            <Accordion.Body className="accordion-body">
            Encuesta Código de Conducta 2023
              <a href="/Cepci/Cepcidoc05">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="5" className="accordion-CONTR5">
            <Accordion.Header>
            Directorio
            </Accordion.Header>
            <Accordion.Body className="accordion-body">
            Directorio 2025
              <a href="/Cepci/Cepcidoc08">
                <button style={{ fontSize: "10px", padding: "3px 7px" }}>PDF</button>
              </a>
            </Accordion.Body>
          </Accordion.Item> 
        </Accordion>
      </div>

    </div>





  );
}

export default Etica;
